import type { TEmployeesState } from '@/types/state-types'
import UserCreate from '@/models/users/UserCreate'
import UserForm from '@/models/users/UserForm'

export default <TEmployeesState>{
  employeeForm: new UserCreate(),
  isEmployeeLoading: false,
  selectedUser: { ...new UserForm(), isLoading: false },
}
